import { Injectable } from '@angular/core';
import { LoadConfigService } from './load-config.service';
import { UtilsService } from './utils.service';
import { StudyNavigationService } from './study-navigation.service';
import { profile } from 'console';

@Injectable({
  providedIn: 'root',
})
export class LoadNeedsphereService {
  private config: Object;
  private defaultLng: string;

  constructor(
    private loadConfigService: LoadConfigService,
    private utils: UtilsService,
    private navigationService: StudyNavigationService
  ) {
    this.config = this.loadConfigService.getConfig();
    this.defaultLng = this.loadConfigService.getDefaultLanguage();
  }

  getNeedsDemo(lng: string = this.defaultLng): string[] {
    const demoNeeds = this.config['demoNeeds'];
    const translatedDemoNeeds = demoNeeds[lng].slice();
    const demoNeedsRepetition = this.getDemoRepetitions();

    return this.utils.shuffleRepetitions(
      translatedDemoNeeds,
      demoNeedsRepetition
    );
  }

  private getNeeds(lng: string = this.defaultLng): Object {
    const needs = this.config['needsphere'];
    const translatedNeeds = needs[lng];

    return this.utils.makeDeepCopy(translatedNeeds);
  }

  private getBrandNeeds(lng: string = this.defaultLng) {
    const brandNeeds = {
      ...this.getNeeds(lng),
      ...this.utils.makeDeepCopy(this.loadConfigService.getBrandNeeds(lng)),
    };

    return brandNeeds;
  }

  private getModularNeeds(lng: string = this.defaultLng) {
    const currIATidx = this.navigationService.getTestId();

    const currIATconfig =
      this.loadConfigService.getRandomizedTestByIdx(currIATidx);

    const modularNeeds = currIATconfig['config']['needs'][lng];
    return this.utils.makeDeepCopy(modularNeeds);
  }

  // TODO: remove after making sure that it's not used anywhere. brand images should be fetched from the client config
  getBrandImages() {
    return this.config['brandImages'].slice();
  }

  getRepetitions(): number {
    return this.config['needsRepetition'];
  }

  getDemoRepetitions(): number {
    return this.config['demoNeedsRepetition'];
  }

  getNeedsArray(lng: string = this.defaultLng): string[] {
    return this.utils.flattenObject(this.getNeeds(lng));
  }

  getBrandNeedsArray(lng: string = this.defaultLng): string[] {
    return this.utils.flattenObject(this.getBrandNeeds(lng));
  }

  getModularNeedsArray(lng: string = this.defaultLng): string[] {
    // changed for neurobrand valuation
    return this.utils.flattenObject(this.getBrandNeeds(lng));
  }

  getNeedsWithRepetitions(
    IATtype: string,
    lng: string = this.defaultLng
  ): string[] {
    let needsArray;
    if (IATtype === 'agreement') {
      //! currently out of scope
      return;
    }
    if (IATtype === 'persona') {
      needsArray = this.getNeedsArray(lng);
    }

    if (IATtype === 'brand') {
      needsArray = this.getBrandNeedsArray(lng);
    }

    if (IATtype === 'modular') {
      needsArray = this.getModularNeedsArray(lng);
    }

    return this.utils.shuffleRepetitions(needsArray, this.getRepetitions());
  }

  getForcedChoiceNeeds(arr: string[]) {
    const needs = arr.slice();

    const forcedChoicedNeeds = [];
    // create all combinations of needs
    for (let i = 0; i < needs.length; i++) {
      for (let j = i + 1; j < needs.length; j++) {
        forcedChoicedNeeds.push(this.utils.shuffle([needs[i], needs[j]]));
      }
    }

    const shuffledNeeds = this.utils.shuffle(forcedChoicedNeeds);

    // needed in order to get fade out animation to work as animation only restarts if the displayed word changes
    for (let i = 1; i < shuffledNeeds.length; i++) {
      const prev = shuffledNeeds[i - 1];
      const curr = shuffledNeeds[i];

      if (prev[0] === curr[0] || prev[1] === curr[1]) {
        [shuffledNeeds[i][0], shuffledNeeds[i][1]] = [
          shuffledNeeds[i][1],
          shuffledNeeds[i][0],
        ];
      }
    }

    return shuffledNeeds;
  }
}
